"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serializePair = function (key, value) {
    return typeof value !== 'undefined' ? key + "=" + encodeURIComponent(value) : null;
};
var createQuery = function (query) {
    return Object.entries(query)
        .reduce(function (params, _a) {
        var key = _a[0], value = _a[1];
        return params.concat(Array.isArray(value)
            ? value.map(function (value) { return serializePair(key + "[]", value); })
            : serializePair(key, value));
    }, [])
        .filter(function (x) { return !!x; })
        .join('&');
};
var getUrl = function (base, path, query) {
    return [
        base,
        path,
        query && Object.keys(query).length > 0 ? '?' : '',
        query && createQuery(query)
    ]
        .filter(Boolean)
        .join('');
};
exports.default = getUrl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/getUrl.js
// module id = 126
// module chunks = 70